if (!window.VideoGalleryPlayer) {
  class VideoGalleryPlayer {
    constructor(root) {
      this.root = root;
      if (!this.root) return;

      this.player = this.root.querySelector('[data-video-player]');
      this.trigger = this.root.querySelector('[data-video-trigger]');
      this.isAutoplay = this.root.dataset.autoplay === 'true';

      this.boundPauseRequest = this.onPauseRequest.bind(this);
      this.boundPlayRequest = this.onPlayRequest.bind(this);
      this.boundResize = this.onResize.bind(this);

      this.init();
    }

    init() {
      if (this.root.dataset.playerInitialized === 'true') return;
      this.root.dataset.playerInitialized = 'true';

      this.bindEvents();

      if (this.isAutoplay) {
        if (this.player) this.player.hidden = false;
        this.root.classList.add('is-playing');
      }
    }

    bindEvents() {
      if (this.trigger) {
        this.trigger.addEventListener('click', () => {
          this.play();
        });
      }

      this.root.addEventListener('theme:video:pause-request', this.boundPauseRequest);
      this.root.addEventListener('theme:video:play-request', this.boundPlayRequest);
      window.addEventListener('resize', this.boundResize);
    }

    destroy() {
      this.root.removeEventListener('theme:video:pause-request', this.boundPauseRequest);
      this.root.removeEventListener('theme:video:play-request', this.boundPlayRequest);
      window.removeEventListener('resize', this.boundResize);
    }

    getVisibleContainer() {
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      return this.root.querySelector(mobile ? '.video-gallery-player__mobile' : '.video-gallery-player__desktop');
    }

    getVisibleVideo() {
      const container = this.getVisibleContainer();
      return container ? container.querySelector('video') : null;
    }

    getVisibleIframe() {
      const container = this.getVisibleContainer();
      return container ? container.querySelector('iframe') : null;
    }

    playIframe(iframe) {
      if (!iframe) return;
      try {
        const src = iframe.src || '';
        if (src.includes('youtube.com') || src.includes('youtube-nocookie.com')) {
          iframe.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: 'playVideo',
            args: []
          }), '*');
        } else if (src.includes('vimeo.com')) {
          iframe.contentWindow.postMessage({ method: 'play' }, '*');
        }
      } catch (e) {}
    }

    pauseIframe(iframe) {
      if (!iframe) return;
      try {
        const src = iframe.src || '';
        if (src.includes('youtube.com') || src.includes('youtube-nocookie.com')) {
          iframe.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: 'pauseVideo',
            args: []
          }), '*');
        } else if (src.includes('vimeo.com')) {
          iframe.contentWindow.postMessage({ method: 'pause' }, '*');
        }
      } catch (e) {}
    }

    play() {
      if (this.player) this.player.hidden = false;
      this.root.classList.add('is-playing');

      const video = this.getVisibleVideo();
      const iframe = this.getVisibleIframe();

      if (video) {
        const promise = video.play();
        if (promise && typeof promise.catch === 'function') {
          promise.catch(() => {});
        }
      } else if (iframe) {
        this.playIframe(iframe);
      }

      this.root.dispatchEvent(new CustomEvent('theme:video:play', {
        bubbles: true,
        detail: { id: this.root.dataset.videoId }
      }));
    }

    pause() {
      const video = this.getVisibleVideo();
      const iframe = this.getVisibleIframe();

      if (video) {
        try { video.pause(); } catch (e) {}
      } else if (iframe) {
        this.pauseIframe(iframe);
      }

      this.root.classList.remove('is-playing');

      this.root.dispatchEvent(new CustomEvent('theme:video:pause', {
        bubbles: true,
        detail: { id: this.root.dataset.videoId }
      }));
    }

    pauseAllMedia() {
      this.root.querySelectorAll('video').forEach((video) => {
        try { video.pause(); } catch (e) {}
      });

      this.root.querySelectorAll('iframe').forEach((iframe) => {
        this.pauseIframe(iframe);
      });
    }

    onPauseRequest() {
      this.pause();
    }

    onPlayRequest() {
      this.play();
    }

    onResize() {
      if (!this.root.classList.contains('is-playing')) return;
      this.pauseAllMedia();
    }
  }

  window.VideoGalleryPlayer = VideoGalleryPlayer;
}

if (!window.__videoGalleryPlayerInit) {
  window.__videoGalleryPlayerInit = true;
  window.__videoGalleryPlayerInstances = window.__videoGalleryPlayerInstances || new Map();

  window.initVideoGalleryPlayer = function(scope = document) {
    const players = scope.querySelectorAll('[data-video-wrapper]');
    players.forEach((playerRoot) => {
      const playerId = playerRoot.dataset.videoId || Math.random().toString(36).slice(2);

      if (window.__videoGalleryPlayerInstances.has(playerId)) return;

      const instance = new window.VideoGalleryPlayer(playerRoot);
      window.__videoGalleryPlayerInstances.set(playerId, instance);
    });
  };

  window.destroyVideoGalleryPlayerByScope = function(scope = document) {
    const players = scope.querySelectorAll('[data-video-wrapper]');
    players.forEach((playerRoot) => {
      const playerId = playerRoot.dataset.videoId;
      if (!playerId) return;

      const instance = window.__videoGalleryPlayerInstances.get(playerId);
      if (!instance) return;

      instance.destroy();
      window.__videoGalleryPlayerInstances.delete(playerId);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.initVideoGalleryPlayer(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    window.initVideoGalleryPlayer(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    window.destroyVideoGalleryPlayerByScope(event.target);
  });
}